import { Component, Input } from '@angular/core';
import { trackByRef } from 'src/app/lego-utils';
import { IValidation, ValidationState } from 'src/app/models';
import { ValidationDiagnosticsReportService } from 'src/app/services';

interface IIconValues {
  color: string;
  borderColor: string;
  icon: string;
}

@Component({
  selector: 'em-validation-item',
  styleUrls: ['./validation-item.component.less'],
  templateUrl: './validation-item.component.html',
  standalone: false,
})
export class ValidationItemComponent {
  public readonly trackByRef = trackByRef;
  public validationState = ValidationState;
  public iconValue?: IIconValues;
  public reportedEventId?: string;

  private validationItemValue?: IValidation;

  public constructor(
    private readonly diagnosticsReportService: ValidationDiagnosticsReportService
  ) {}

  @Input() public set validationItem(validation: IValidation | undefined) {
    this.iconValue = this.getIconFromValidationState(validation);
    this.validationItemValue = validation;

    // A new result for this rule means the previous report no longer describes what is on
    // screen, so the action becomes available again.
    this.reportedEventId = undefined;
  }

  public get validationItem() {
    return this.validationItemValue;
  }

  /** Only rules that supplied diagnostics have anything worth sending. */
  public get canReport() {
    return !!this.validationItemValue?.diagnostics;
  }

  public report() {
    if (!this.validationItemValue) {
      return;
    }

    this.reportedEventId = this.diagnosticsReportService.report(this.validationItemValue);
  }

  private getIconFromValidationState(validation: IValidation | undefined) {
    const state = validation ? validation.validationState : undefined;

    switch (state) {
      case ValidationState.VALID:
        return {
          borderColor: 'rgba(0, 150, 0, 0.8)',
          color: 'rgba(0, 150, 0, 0.2)',
          icon: 'check',
        };

      case ValidationState.FAILED:
        return {
          borderColor: 'rgba(150, 0, 0, 0.8)',
          color: 'rgba(150, 0, 0, 0.2)',
          icon: 'close',
        };

      case ValidationState.WARNING:
        return {
          borderColor: 'rgba(245, 188, 66, 1)',
          color: 'rgba(245, 188, 66, 0.2)',
          icon: 'exclamation',
        };

      default:
        return {
          borderColor: 'rgba(0, 0, 150, 0.8)',
          color: 'rgba(0, 0, 150, 0.2)',
          icon: '',
        };
    }
  }
}
